/**
 * 邮箱管理器
 * 负责管理邮箱信息，提供获取、更新等功能
 * @author 杨俊朗
 */
export class IamInviteIamEmailManager {
  private static instance: IamInviteIamEmailManager;
  private store: string = "";

  private constructor() {}

  // 单例模式
  public static getInstance(): IamInviteIamEmailManager {
    if (!IamInviteIamEmailManager.instance) {
      IamInviteIamEmailManager.instance = new IamInviteIamEmailManager();
    }
    return IamInviteIamEmailManager.instance;
  }

  // 更新邮箱信息
  public update(value: string): void {
    console.log("update email store", value, import.meta.url);
    this.store = value;
  }

  // 获取邮箱信息
  public get(): string {
    return this.store;
  }

  // 清除邮箱信息
  public clear(): void {
    this.update("");
  }
}

export const iamInviteIamEmailManager = IamInviteIamEmailManager.getInstance();
